import { Grid } from "@material-ui/core";
import * as React from "react";
import { useEffect, useState } from "react";
import { ErrorModal } from "../../../components/modals/error-modal";
import { LazyLoading } from "../../../controls/LazyLoading/LazyLoading";
import {
	getEmailAddresses,
	getEmailTopics,
} from "../emailTopics/repositories/EmailTopicsRepository";
import { TableEmailAddresses } from "./components/TableEmailAddresses";
import { useEmailAddressesContext } from "./context/EmailAddressesContext";

export const EmailAddressesPage = () => {
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");
	const {
		actions: { setAddresses, setTopics, setAddressTopics },
	} = useEmailAddressesContext();

	// The topic list is loaded alongside the addresses because the assignment form needs it, and
	// pulling it once here keeps every modal from asking for it again.
	const getEmailAddressesFromAPI = async () => {
		setIsLoading(true);
		try {
			const [addresses, topics] = await Promise.all([
				getEmailAddresses(),
				getEmailTopics(),
			]);
			setAddresses(addresses);
			setTopics(topics.topics);
			setAddressTopics(topics.addresses);
		} catch (e: any) {
			setError(e?.message || "Error fetching email addresses");
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		getEmailAddressesFromAPI();
	}, []);

	if (isLoading) {
		return (
			<Grid
				container
				justifyContent="center"
				alignItems="center"
				style={{ height: "70vh", width: "100%" }}
			>
				<LazyLoading />
			</Grid>
		);
	}

	return (
		<Grid container justifyContent="center" alignItems="center">
			<ErrorModal error={error} onHide={() => setError("")} />
			<div style={{ width: "100%", padding: "10px 0 20px" }}>
				<TableEmailAddresses
					isLoading={isLoading}
					getEmailAddressesFromAPI={getEmailAddressesFromAPI}
				/>
			</div>
		</Grid>
	);
};
